import { Banner, Button } from '@shared/design-system/ui'

export type ProfileSaveOutcome = { kind: 'accepted' } | { kind: 'lookup_failed' }

export function ProfileSaveOutcomeMessage({
  outcome,
  onRefresh,
  refreshing = false,
}: {
  outcome: ProfileSaveOutcome
  onRefresh?: () => void | Promise<void>
  refreshing?: boolean
}) {
  if (outcome.kind === 'accepted') {
    return <Banner tone="success" title="Dados salvos e enviados" />
  }

  return (
    <Banner
      tone="warning"
      title="Dados salvos, mas não foi possível consultar o andamento"
      action={
        onRefresh ? (
          <Button
            variant="secondary"
            size="sm"
            disabled={refreshing}
            onClick={() => void onRefresh()}
          >
            {refreshing ? 'Atualizando...' : 'Atualizar status'}
          </Button>
        ) : undefined
      }
    >
      Atualize o painel de verificação para conferir o andamento do cadastro.
    </Banner>
  )
}
